import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { SideBarMenu } from "../../../../types/SidebarMenu";
import { getAxios, route } from "../../../../utils/endpoints";

interface SidebarState {
  items: SideBarMenu[];
  isLoading: boolean;
  error: string | null;
}

const initialState: SidebarState = {
  items: [],
  isLoading: false,
  error: null,
};

export const fetchSidebar = createAsyncThunk<
  SideBarMenu[],
  void,
  { rejectValue: string }
>("sidebar/fetchMenu", async (_, { rejectWithValue }) => {
  console.log("ENTERING FETCH SIDEBAR FUNCTION");

  try {
    console.log("TRY TO RETRIEVE DATA");
    const response = await getAxios(route.apiSidebar.sideMenu, "GET");

    if (!response.data || typeof response.data === "string") {
      console.log("DATA COMES UNDEFINED OR EMPTY STRING");
      console.log("IF RESULT: ", response.data);

      return [];
    }

    console.log("RESULT SUCCESS, DATA: ", response.data);
    return response.data as SideBarMenu[];
  } catch (error) {
    console.error("Error fetching menu: ", error);

    const message =
      error instanceof Error ? error.message : "Failed to fetch menu";

    return rejectWithValue(message);
  }
});

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    clearSidebar(state) {
      state.items = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSidebar.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(fetchSidebar.fulfilled, (state, action) => {
      state.items = action.payload;
      state.isLoading = false;
      state.error = null;
    });

    builder.addCase(fetchSidebar.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Failed to fetch sidebar";
      state.items = [];
    });
  },
});

export const { clearSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;
